import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { Divider } from './Divider';
export function PricingSection() {
  return <section id="pricing" className="w-full bg-[#0A1535] py-20 px-6 relative overflow-hidden" data-id="element-189" data-mp="19gt13unp79an">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_rgba(224,183,86,0.15)_0%,_transparent_70%)]" style={{
      backgroundColor: "#5B401F",
      backgroundImage: "none"
    }} data-id="element-190" data-mp="1ege0u7aozlof"></div>

      <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-191" data-mp="1s9n6bwvirn1o">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-12" data-id="element-192" data-mp="1s7skmgcfbqwj">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-193" data-mp="2up6aepcwa14">
            Tu inversión hoy:{' '}
            <span className="text-[#E0B756]" data-id="element-194" data-mp="7tilqco7eb3x">$17 dólares</span>
          </h2>

          <Divider data-id="element-195" data-mp="7vmt54lb9s8y" />

          <p className="text-lg md:text-xl text-gray-300 leading-relaxed mb-8" style={{
          color: "#F7F2E7"
        }} data-id="element-196" data-mp="1mh6j0uul2u3c">
            Todo el programa completo — Método R.E.V.E.L.A. el entrenamiento de 30 días, los 3 obsequios exclusivos y acceso inmediato — por una inversión única de $17 dólares.
          </p>

          <p className="text-lg text-gray-400 mb-8" style={{
          color: "#F7F2E7"
        }} data-id="element-197" data-mp="17stl3sbxr167">
            Sin mensualidades. Sin compromisos. Sin letra pequeña.
          </p>

          <p className="text-xl text-white font-semibold mb-12" data-id="element-198" data-mp="20gfx9oz8be4o">
            Solo tú, Dios y 30 días que pueden cambiarlo todo.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-[#0B1A3A] rounded-2xl p-2 mb-8 text-left max-w-2xl mx-auto ring-1 ring-[#E0B756]/60 shadow-[0_0_30px_rgba(224,183,86,0.12)]" style={{
        backgroundColor: "#5B401F",
        backgroundImage: "none"
      }} data-id="element-199" data-mp="1vfjkelwwghn4">
          <div className="border border-[#E0B756]/40 rounded-xl p-6 md:p-9" style={{
          backgroundColor: "#5B401F",
          backgroundImage: "none"
        }} data-id="element-200" data-mp="hhi1p6lamkfv">
            <h3 className="text-xl md:text-2xl font-bold text-white text-center mb-6" data-id="element-201" data-mp="mg32p88dd85d">
              Esto es todo lo que recibes hoy
            </h3>

            <ul className="divide-y divide-[#E0B756]/15" data-id="element-202" data-mp="ci5e2jmll9c8">
              {[{
              label: 'Método R.E.V.E.L.A. — Programa principal de 30 días',
              value: '$37 USD'
            }, {
              label: 'Bono 1 — Libreta de Gratitud y Provisión',
              value: '$17 USD'
            }, {
              label: 'Bono 2 — 4 Meditaciones Guiadas R.E.V.E.L.A.',
              value: '$25 USD'
            }, {
              label: 'Bono 3 — 100 Promesas Bíblicas',
              value: '$15 USD'
            }].map(item => <li key={item.label} className="flex items-center justify-between gap-4 py-3" style={{
              backgroundColor: "#5B401F",
              backgroundImage: "none"
            }} data-id="element-203" data-mp="3py32w17oo98f">
                  <span className="flex items-start gap-3 text-gray-300 text-sm md:text-base" style={{
                color: "#F7F2E7",
                backgroundColor: "#5B401F",
                backgroundImage: "none"
              }} data-id="element-204" data-mp="3fzx3bq9cnf6q">
                    <CheckCircle2 className="w-5 h-5 text-[#E0B756] flex-shrink-0 mt-0.5" data-id="element-205" data-mp="2sc089e3yuf9y" />
                    {item.label}
                  </span>
                  <span className="text-gray-400 line-through text-sm md:text-base flex-shrink-0" style={{
                color: "#F7F2E7"
              }} data-id="element-206" data-mp="36ckruchpgf4i">
                    {item.value}
                  </span>
                </li>)}
            </ul>

            <div className="flex items-center justify-between gap-4 pt-5 mt-3 border-t border-[#E0B756]/30" data-id="element-207" data-mp="3g84ncxscxbsq">
              <span className="text-white font-semibold text-base md:text-lg" data-id="element-208" data-mp="3b8ryy8lu7wo1">
                Valor total real
              </span>
              <span className="text-gray-400 line-through text-lg md:text-xl flex-shrink-0" style={{
              color: "#F7F2E7"
            }} data-id="element-209" data-mp="3l05te1yxm6ab">
                $94 USD
              </span>
            </div>

            <div className="flex items-center justify-between gap-4 mt-4 bg-[#E0B756]/10 border border-[#E0B756]/40 rounded-xl px-5 py-4" data-id="element-210" data-mp="3u1dtmpl0dh71">
              <span className="text-[#E0B756] font-bold text-lg md:text-xl" data-id="element-211" data-mp="hx178kds6wds">
                Hoy, todo por solo
              </span>
              <span className="text-[#E0B756] font-bold text-2xl md:text-3xl flex-shrink-0" data-id="element-212" data-mp="lxl7hwtnig45">
                $17 USD
              </span>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} id="oferta-final" className="scroll-mt-8 bg-gradient-to-br from-[#0B1A3A] to-[#0A1535] border-2 border-[#E0B756] rounded-2xl p-8 md:p-12 mb-8" style={{
        backgroundImage: "linear-gradient(180deg, #5B401F 0%, rgb(91, 64, 31) 100%)"
      }} data-id="element-213" data-mp="vopjqorxzmva">
          <h3 className="text-2xl md:text-3xl font-bold text-white mb-4" data-id="element-214" data-mp="d0kl1vq56s3c">
            Comienza hoy tu experiencia con el Método R.E.V.E.L.A.
          </h3>
          <p className="text-xl text-[#E0B756] mb-6" data-id="element-215" data-mp="1odn2su3z9np3">
            30 Días con Dios para Vivir en Abundancia desde la Fe
          </p>
          <p className="text-lg text-gray-300 mb-8 leading-relaxed" style={{
          color: "#F7F2E7"
        }} data-id="element-216" data-mp="38uw0doatz8ut">
            Renueva tu mente, fortalece tu fe y experimenta paz, provisión y
            abundancia en tu vida diaria.
          </p>

          <motion.a href="https://pay.hotmart.com/A105236382M" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} animate={{
          boxShadow: ['0 0 20px rgba(224,183,86,0.3)', '0 0 40px rgba(224,183,86,0.5)', '0 0 20px rgba(224,183,86,0.3)']
        }} transition={{
          boxShadow: {
            duration: 2,
            repeat: Infinity,
            ease: 'easeInOut'
          }
        }} className="block w-full text-center bg-gradient-to-r from-[#C9A24B] to-[#E0B756] text-[#0A1535] font-bold text-xl px-12 py-6 rounded-full shadow-lg hover:shadow-2xl transition-shadow focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#E0B756] focus-visible:ring-offset-2 focus-visible:ring-offset-[#0A1535]" style={{
          color: "#F7F2E7"
        }} data-id="element-217" data-mp="2z41am9ydlr4m">
            QUIERO COMENZAR MIS 30 DÍAS CON DIOS — $17 USD
          </motion.a>

          <p className="text-[#E0B756] text-sm mt-6" data-id="element-218" data-mp="28nqw8vwbfsbm">
            Acceso inmediato - Pago único en tu moneda local - 
          </p>
        </motion.div>
      </div>
    </section>;
}